









































import { LeadService } from "@/services/lead.service";
import { Component } from "vue-property-decorator";
import { required } from "@/shared/validators";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboMensagemPronta from "../components/ComboMensagemPronta.vue";

@Component({
  components: { Modal, ComboMensagemPronta },
})
export default class RetornoOctadesk extends mixins(GlobalMixin) {
  idMensagemPronta: number | null = null;
  nomeCampanha: string | null = null;
  arquivo: File | null = null;
  loading = false;

  rules = {
    campanha: [required()],
    mensagemPronta: [required()],
    arquivo: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async retornoOctadesk() {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarImportacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        await LeadService.retornoOctadesk(
          this.arquivo!,
          this.nomeCampanha!,
          this.idMensagemPronta!
        );

        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
